import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const QRScannerContainer = styled.div({
  display: 'flex',
  flex: 1,
  width: '100%',
  height: '100%',
  flexDirection: 'column',
})

export const HeaderContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  minHeight: '60px',
  background: v.ezMainColor,
  padding: '0px 10px',

  'div.applicationName': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#FFF',

    'h6':{
      fontWeight:'bold'
    }
  },
})

export const QRScannerBody = styled.div({
  display: 'flex',
  flex: 1,
  width: '100%',
  background: v.ezGrayColor,
  paddingTop: '20px',

  '.leftContent': {
    display: 'flex',
    flex: 2,
    alignItems: 'center',
    flexDirection: 'column',

    'span.title': {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginBottom: '10px',
    },

    form: {
      width: '100%',
    }
  },

  '.rightContent': {
    display: 'flex',
    flex: 5,
    paddingLeft: '10px',
    flexDirection: 'column',
    paddingRight: '10px',

    'span.title': {
      fontSize: '2.125rem',
      fontWeight: 'bold',
      marginBottom: '10px',
    }
  },
})

export const DocumentDataSection = styled.div({
  display: 'flex',
  padding: '10px',
  borderRadius: '5px',
  width: '100%',
  background: v.bgSoftGray,
  marginBottom: '10px',
  flexDirection: 'column',

  'span.sectionTitle': {
    marginBottom: '5px',
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },

  'div.row': {
    display: 'flex',
    flexDirection: 'row',

    'div.title': {
      fontWeight: 'bold',
      flex: 1,
    },

    'div.value': {
      flex: 9,
    },
  }
})